import type { PresetComponentType } from '../../gql';

import { randBoolean } from '@ngneat/falso';

import { ComponentType } from '../../gql';

import { mockPresetColour } from './mockPresetColour';

const mockPresetComponentType = (
    overwrite?: Partial<PresetComponentType>
): PresetComponentType => ({
    type: ComponentType.Standard,
    areColoursSplit: randBoolean(),
    isDyedToMatch: randBoolean(),
    isDyedToMatchLocked: false,
    presetColours: [
        mockPresetColour({ colourPositionIndex: 0 }),
        mockPresetColour({ colourPositionIndex: 1 }),
    ],
    ...overwrite,
});

export { mockPresetComponentType };
